import { useState } from 'react';
// @mui
import {
  Stack,
  Dialog,
  DialogTitle,
  DialogProps,
  DialogActions,
  DialogContent,
} from '@mui/material';
import MenuPopover from '@/commons/menu-popover';
import { RHFTextField } from '@/commons/hook-form';
import { translates } from '@/utils';
import { Button } from '@PorkyCol/button';


interface Props extends DialogProps {
  onClose: VoidFunction;
  name: string;
}

export default function PaymentNewCardDialog({ onClose, name, ...other }: Props) {
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <Dialog maxWidth="xs" onClose={onClose} {...other}>
        <DialogTitle> {translates.addAmountToCancel} </DialogTitle>

        <DialogContent sx={{ overflow: 'unset' }}>
          <Stack spacing={3}>
            <RHFTextField
              InputProps={{
                inputProps: {
                  min: 1,
                },
              }}
              type="number"
              name={`${name}.value`}
              label={translates.value}
              placeholder={translates.valueTransaction}
              InputLabelProps={{ shrink: true }}
            />
            {name !== 'cash' && (
              <RHFTextField
                name={`${name}.transaction`}
                label={translates.transaction}
                placeholder={translates.numberTransaction}
                InputLabelProps={{ shrink: true }}
              />
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button color="danger" variant="solid" onClick={onClose}>
            {translates.cancel}
          </Button>

          <Button variant="solid" color="success" onClick={onClose}>
            {translates.add}
          </Button>
        </DialogActions>
      </Dialog>

      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        arrow="bottom-center"
        sx={{ maxWidth: 200, typography: 'body2', textAlign: 'center' }}
      >
        Three-digit number on the back of your VISA card
      </MenuPopover>
    </>
  );
}
